import React from "react";

export const DrawerContext = React.createContext<
  | {
      isDrawer?: boolean;
    }
  | undefined
>(undefined);
